import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaFlowRandomImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.FLOW_RANDOM;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTests = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        const idsPreguntaSiguientes: number[] = [];
        pasoTests = pasoTests && datos.slice(1).every(hijo => {
            if (hijo.preguntaSiguiente == null) {
                this.errores.push(`La pregunta siguiente de ${hijo.idPregunta} no puede estar vacio`);
                return false;
            }
            if (!idsPreguntaSiguientes.includes(hijo.preguntaSiguiente)) {
                idsPreguntaSiguientes.push(hijo.preguntaSiguiente);
            } else {
                this.advertencias.push(
                    `Hay otro item que apunta a la pregunta ${hijo.preguntaSiguiente} en la pregunta ${preguntaPadre.idPregunta}`
                );
            }
            return true;
        });
        return pasoTests;
    }
}
